var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { fill: "#e4edfd", id: "Symbols", fillRule: "evenodd" },
      React.createElement("path", { d: "M10.297 11h3.406L12 4.519z", transform: "rotate(45 12 12)" }),
      React.createElement("path", { d: "M15 12l-2.323 8.84c-.183.695-1.171.695-1.354 0L9 12l2.323-8.84A.684.684 0 0 1 12 2.639c.293 0 .585.173.677.521L15 12zM12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0z", transform: "rotate(45 12 12)" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/NavBar/icons/Discover.svg